module.exports = {
  type: 'spa',
  isTenanted: true,
  publicPath: '/fmo-home/',
  octopusPackageId: 'fleet-portal-home',
  octopusProjectName: 'Fleet Portal Home',
  mountDOMId: '__app__',
  standalone: false,
  frameless: true
};